import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase } from '@fortawesome/free-solid-svg-icons';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import '../assets/styles/Timeline.scss'

function Timeline() {
  return (
    <div id="history">
      <div className="items-container">
        <h1>Career History</h1>
        <VerticalTimeline>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="Jun 2012 – Present"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Senior Full-Stack Engineer &amp; Technical Lead</h3>
            <h4 className="vertical-timeline-element-subtitle"><a href="https://g2o.com" target="_blank" rel="noreferrer">G2O</a> (formerly ICC) — IT Consulting — Columbus, OH</h4>

            <ul>
              <li>
                Delivered 10+ client engagements across banking, government, logistics, healthcare, and material handling — progressing from junior developer to senior engineer and program lead over 13+ years.
              </li>
              <li>
                G2O <strong>Impact Award</strong> recipient — the company's highest honor across 300+ employees — recognized for exceptional lead skills and outstanding client delivery.
              </li>
              <li>
                Led teams of 2–15 developers; responsibilities included architecture design, code reviews, mentoring, sprint planning, and full project lifecycle ownership from requirements through production support.
              </li>
              <li>
                Reporting Manager for up to 5 direct reports: performance reviews, compensation recommendations, PTO approvals, and career development guidance.
              </li>
              <li>
                Interviewed and evaluated full-stack engineering candidates; led client discovery sessions, built proof-of-concept solutions, scoped projects, and prepared technical proposals and cost estimates.
              </li>
            </ul>

          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="Jan 2024 – Present"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Senior Full-Stack Engineer</h3>
            <h4 className="vertical-timeline-element-subtitle">G2O / Crown Equipment — InfoLink 6 Global Fleet Management Platform — Remote</h4>
            <ul>
              <li>
                Built a greenfield Angular 20 energy management module for InfoLink 6 — a global warehouse fleet management platform — including a real-time dashboard, configurable report generation (email/mobile), and equipment battery threshold controls.
              </li>
              <li>
                Engineered and maintained 20+ Java 17 Spring Boot microservices across ~10 repos, with JWT/Auth0 security, Spring Data/JPA, Redis caching, Flyway migrations, and AWS integrations (SQS, SNS, S3, DynamoDB, RDS Aurora).
              </li>
              <li>
                Led the Custom Roles initiative: redesigned platform-wide authorization and delivered a role-creation wizard with a permission matrix grid spanning 15+ Angular repos, eliminating the need for manual development tickets for customer personalization requests.
              </li>
              <li>
                Managed CI/CD via GitHub Actions; Jasmine/Karma for frontend unit tests; Mockito/JUnit for backend; integrated Snaplogic ETL pipelines and Firebase push notifications for mobile.
              </li>
              <li>
                Worked across 3+ UI repos and 20+ total git repos simultaneously; introduced Docker for local development.
              </li>
            </ul>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="Jun 2023 – Jan 2024"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Development Lead</h3>
            <h4 className="vertical-timeline-element-subtitle">G2O / State of Ohio (OESCA, INFOhio) &amp; Everglades Foundation — Remote</h4>
            <ul>
              <li>
                Led full-stack delivery of <strong>ohiopld.org</strong> (OESCA) — a professional learning catalog for Ohio educators — using React, Node.js, AWS, and Elasticsearch.
              </li>
              <li>
                Led full-stack delivery of <strong>infohio.org</strong> — a LAMP stack application (React/TypeScript, PHP/Laravel, MySQL) with Apache server configuration and Jenkins CI/CD.
              </li>
              <li>
                Development Lead for the Everglades Foundation's <strong>evergladesecoquest.org</strong> using Azure Functions, Cosmos DB, React, and Azure Pipelines.
              </li>
              <li>
                Led a team of developers across all three platforms; provided code reviews, technical guidance, bug fixes, enhancements, and direct client communication.
              </li>
            </ul>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="Feb 2020 – Aug 2023"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Program Lead / Technical Lead</h3>
            <h4 className="vertical-timeline-element-subtitle">G2O / State of Ohio — InnovateOhio Platform (IOP) — Remote</h4>
            <ul>
              <li>
                Directed a 3.5-year, 12-project program modernizing citizen-facing websites for 30+ Ohio state agencies within the state's enterprise web content management system.
              </li>
              <li>
                Architected custom React/Redux applications and reusable component libraries used across agencies; implemented AWS Lambda content feed pipelines and bulk upload workflows via S3.
              </li>
              <li>
                Integrated SSO/OAuth, RSA key-pair auth, and WCAG accessibility compliance with screen reader support; third-party integrations with Monster.com, Form.io, ESRI Maps, and social media platforms.
              </li>
              <li>
                Owned the full project lifecycle per agency: requirements gathering, architecture, build, and up to 12 months of post-launch production support.
              </li>
              <li>
                Tech stack: IBM CMS, React, HTML, SCSS, JavaScript, jQuery, AWS (S3, Lambda, Secrets Manager, SES, KMS, API Gateway), Form.io, OAuth.
              </li>
            </ul>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="Nov 2019 – Feb 2020"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Senior Integration Developer</h3>
            <h4 className="vertical-timeline-element-subtitle">G2O / M&amp;T Bank — Remote</h4>
            <ul>
              <li>
                ESB developer on the integration team: developed and promoted changes through multiple environments using Tibco BW Designer, IBM MQ, and Jenkins CI/CD pipelines.
              </li>
              <li>
                Built Spring Boot REST business service APIs with security framework for client authorization; supported account opening, customer support, P2P payments, and money transfers.
              </li>
              <li>
                Provided Jenkins CI/CD guidance and setup assistance to the broader development team; used TFS for project planning and capacity tracking.
              </li>
            </ul>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="Feb 2017 – Oct 2019"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Technical Lead</h3>
            <h4 className="vertical-timeline-element-subtitle">G2O / Sarnova — Medical Supply Retail — Remote</h4>
            <ul>
              <li>
                Led architecture and delivery of two internal full-stack applications (Bids and Rewards systems) for the client's sales team, replacing manual Excel workflows and reducing lookup and calculation time significantly.
              </li>
              <li>
                Built the full application environment: Java/Spring Boot, Spring Data/JPA, Spring Batch, Vue.js, MS SQL Server, Apache Solr, Amazon S3, Active Directory/LDAP, Jenkins, Maven, and JUnit with Ruby/Watir automation testing.
              </li>
              <li>
                Owned Epic/Feature/Story planning, client requirement gathering, full project time/cost estimates; worked directly with the client architect on architecture decisions.
              </li>
              <li>
                Implemented data migration from legacy systems and executed full knowledge transfer handoff.
              </li>
            </ul>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="Dec 2015 – Jan 2017"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Senior Developer / Technical Lead</h3>
            <h4 className="vertical-timeline-element-subtitle">G2O / Genco–FedEx — Logistics — Remote</h4>
            <ul>
              <li>
                Led the REST service integration team for a warehouse fulfillment platform; performed gap analysis of current capabilities vs. desired functionality and scoped the MVP.
              </li>
              <li>
                Designed, estimated, and received client approval for new integration flows and services; led the team through sprint-based planning and retrospectives (1–3 week iterations).
              </li>
              <li>
                Mentored developers via code reviews and lunch-and-learn training sessions; owned full lifecycle from business requirements through production deployment and support.
              </li>
            </ul>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="Jun 2013 – Dec 2015"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Integration Developer → Technical Lead → Integration Architect</h3>
            <h4 className="vertical-timeline-element-subtitle">G2O / First Niagara Financial Group — Banking</h4>
            <ul>
              <li>
                Progressed from developer to technical lead to integration architect over a 2.5-year SOA services engagement — one of the most accelerated career progressions in the team's history.
              </li>
              <li>
                Designed and built enterprise service bus integrations using IBM IIB, IBM MQ, Java/Spring, and REST/SOAP — supporting account opening, fund transfers, loan applications, and customer management for front-end teams and vendors.
              </li>
              <li>
                Built automated regression test suites using Ruby/Cucumber/Gherkin/Jenkins/SoapUI; created services with real-time credit card statement retrieval and PII masking from third-party vendors.
              </li>
              <li>
                Managed SVN repository; responsible for DEV and TEST environment deployments and promotion requests across the full development lifecycle.
              </li>
            </ul>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="Jun 2012 – Jun 2013"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Junior Developer / Trainee</h3>
            <h4 className="vertical-timeline-element-subtitle">G2O — In-House Training &amp; Huntington Bank</h4>
            <ul>
              <li>
                Completed G2O's intensive developer training program covering OOP design, unit testing, database design, application construction, design patterns, refactoring, frameworks, and agile methodology.
              </li>
              <li>
                Contributed to an agile loan application project at Huntington Bank: logged and fixed defects in JSP, CSS, JavaScript, SQL, and Java; built automation tests using Ruby, Cucumber, Gherkin, and Jenkins.
              </li>
              <li>
                Tech stack: Java, Spring, JUnit, SQL, Ruby, Cucumber, Watir, Selenium, Jenkins.
              </li>
            </ul>
          </VerticalTimelineElement>

        </VerticalTimeline>
      </div>
    </div>
  );
}

export default Timeline;
